import React, { useState } from "react";
import Select from "react-select";
import { TripStatus } from "./Enums/TripStatus";
import ConfirmWithPhrasePopup from "../Common/ConfirmWithPhrasePopup";
import "../../css/View/TripDetailsInfo.css";
import Loading from "../../Loading";

const TripDetailsInfo = ({ status, isInternalTrip, isCurrentUserMentor, onConfirmStatusChange, isLoading, tripSettlementStatus, takenForSettlementByUser}) => {
  const [selectedStatus, setSelectedStatus] = useState(status.id);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const getStatusClass = (id) => {
    switch (id) {
      case TripStatus.NOT_PUBLISHED:
        return "status-not-published";
      case TripStatus.PUBLISHED_AS_PLANNED:
        return "status-published-as-planned";
      case TripStatus.PUBLISHED:
        return "status-published";
      case TripStatus.INTERNAL_NOT_READY:
        return "status-internal-not-ready";
      case TripStatus.INTERNAL_READY:
        return "status-internal-ready";
      default:
        return "";
    }
  };

  const getColorByClass = (className) => {
    switch (className) {
      case "status-not-published": return "red";
      case "status-published-as-planned": return "orange";
      case "status-published": return "green";
      case "status-internal-not-ready": return "purple";
      case "status-internal-ready": return "#3c9aff";
      default: return "inherit";
    }
  };

  const statusOptions = isInternalTrip
    ? [
        { value: 4, label: "W przygotowaniu", className: "status-internal-not-ready" },
        { value: 5, label: "Gotowa", className: "status-internal-ready" },
      ]
    : [
        { value: 1, label: "Nieopublikowana", className: "status-not-published" },
        { value: 2, label: "W sekcji planowane", className: "status-published-as-planned" },
        { value: 3, label: "Opublikowana", className: "status-published" },
      ];

  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      fontWeight: "bold",
      color: getColorByClass(getStatusClass(state.data.value)),
    }),
    option: (provided, state) => ({
      ...provided,
      color: getColorByClass(getStatusClass(state.data.value)),
      backgroundColor: state.isFocused ? "#eee" : "#fff",
      cursor: "pointer",
    }),
    control: (provided) => ({
      ...provided,
      minWidth: 200,
      fontSize: "14px",
      cursor: "pointer",
    }),
  };

  const handleChange = (selectedOption) => {
    if (selectedOption.value !== selectedStatus) {
      setPendingStatus(selectedOption.value);
      setShowConfirm(true);
    }
  };

  const handleConfirm = () => {
    onConfirmStatusChange(pendingStatus, () => setSelectedStatus(pendingStatus));
    setPendingStatus(null);
    setShowConfirm(false);
  };

  const currentOption = statusOptions.find((opt) => opt.value === selectedStatus);

  return (
<div className="trip-details-header-row">
  <div className="trip-header-item">
    <strong>Typ wycieczki:</strong> {isInternalTrip ? "Wyjazd specjalny" : "Wyjazd otwarty"}
  </div>
  <div className="trip-header-item">
    <strong className="trip-status-label">Status publikacji:</strong><i className="fa-solid fa-bullhorn trip-status-symbol" aria-hidden="true" />{" "}
    {isCurrentUserMentor ? (
      <>
        {isLoading ? (
          <i className="fa-solid fa-spinner fa-spin" style={{ marginLeft: "8px", fontSize: "16px" }} />
        ) : (
          <Select
            isDisabled={isLoading}
            isLoading={isLoading}
            classNamePrefix="status-select"
            value={currentOption}
            onChange={handleChange}
            options={statusOptions}
            styles={customStyles}
          />
        )}
        {showConfirm && (
          <ConfirmWithPhrasePopup
            phrase="okoń"
            text={
              <span>
                Czy na pewno chcesz zmienić status wycieczki na{" "}
                <span className={getStatusClass(pendingStatus)}>
                  {statusOptions.find((o) => o.value === pendingStatus)?.label}
                </span>
                ?
              </span>
            }
            onConfirm={handleConfirm}
            onCancel={() => setShowConfirm(false)}
          />
        )}
      </>
    ) : (
      <span className={getStatusClass(status.id)}>{status.name}</span>
    )}
  </div>
  <div className="trip-header-item">
  <strong className="trip-status-label">Status rozliczenia:</strong><i className="fa-solid fa-coins trip-status-symbol" aria-hidden="true" />
  <span className={`settlement-status-badge settlement-status-${tripSettlementStatus}`}>
    {{
      1: "Zarządzanie po stronie os. koo.",
      2: "Przekazana do rozliczenia os. fin.",
      3: "W trakcie rozliczania przez os. fin. " + takenForSettlementByUser,
      4: "Rozliczona przez os. fin. " + takenForSettlementByUser,
      5: "Zarchiwizowana"
    }[tripSettlementStatus] || "Brak"}
  </span>
</div>
</div>
  );
};

export default TripDetailsInfo;
